<script setup lang="ts">
import type { NuxtError } from 'nuxt/app'
import DefaultLayout from './layouts/default.vue'

useSeoMeta({
  title: 'Page not found',
  description: 'We are sorry but this page could not be found.'
})

defineProps<{
  error: NuxtError
}>()
</script>

<template>
  <DefaultLayout>
    <UError
      :clear="{
        icon: 'i-lucide-arrow-left'
      }"
      :error="{
        statusCode: error?.statusCode || 404,
        statusMessage: 'Page not found',
        message:
          error?.statusMessage || 'The page you are looking for does not exist.'
      }"
    />
  </DefaultLayout>
</template>
